import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import InlineTable, { InlineColDef } from '../util/InlineTable';

interface Stat { id: number; name: string; active: boolean | null; }

const columns: InlineColDef<Stat>[] = [
  { key: 'name', label: t('Name') || 'Name', type: 'text', placeholder: t('Name') || 'Status…' },
];

const Status: React.FC = () => {
  const [rows, setRows] = useState<Stat[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await axios.get('status'); setRows(Array.isArray(data) ? data : []); }
    catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleAdd = async (row: Partial<Stat>) => {
    if (!row.name?.trim()) return;
    await axios.post('status/add', { name: row.name.trim() });
    await load();
  };

  const handleEdit = async (id: string | number, row: Partial<Stat>) => {
    await axios.put(`status/${id}`, { name: row.name });
    await load();
  };

  const handleDelete = async (id: string | number) => {
    if (!window.confirm(t('AreYouSure') || 'Are you sure?')) return;
    await axios.delete(`status/${id}`);
    await load();
  };

  return (
    <div className="bg-[var(--bg-form)] rounded-[5px]" style={{ border: 'var(--border-input)', overflow: 'hidden' }}>
      <InlineTable<Stat>
        columns={columns}
        rows={rows}
        getKey={r => r.id}
        loading={loading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        addLabel={`+ ${t('Stat') || 'Status'}`}
        emptyText={t('Empty') || 'No statuses'}
      />
    </div>
  );
};

export default Status;
